// extracted by mini-css-extract-plugin
export default {"settingsMenu":"Settings_settingsMenu__G-Myh"};